<template>
  <div class="animated fadeIn">
    <div class="font-bold mb-10">Exercise History Analysis</div>
    <div class="box">
      <div class="p-20 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/leads/ehaView?id=' + id_lead_member + '&id_lead=' + id_lead)" class="link-back"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-20 pt-0">
        <form @submit.prevent="validateRegister" v-if="addData">
          <div class="font-bold mt-20">Invited by</div>
          <hr class="short-line left">
          <div class="row mb-30">
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="7">
                  <div class="label-name font-13">Is there someone we can thank for referring you?</div>
                </b-col>
                <b-col sm="5">
                  <b-form-input class="form-control border-bottom" name="question" v-model="addData.question_referring" type="text"></b-form-input>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="7">
                  <div class="label-name font-13">How did you hear about Paradigm Fitness?</div>
                </b-col>
                <b-col sm="5">
                  <b-form-input class="form-control border-bottom" name="question" v-model="addData.question_hear_about" type="text"></b-form-input>
                </b-col>
              </b-row>
            </div>
          </div>
          <div class="font-bold mt-20">Exercise History</div>
          <hr class="short-line left">
          <div class="mb-10">
            <div class="label-name font-13">Have you ever had a membership with a fitness club?</div>
          </div>
          <div class="mb-20">
            <b-form-radio-group id="radios2" v-model="addData.question_had_membership" name="gender">
              <b-form-radio class="font-13" value="yes">Yes</b-form-radio>
              <b-form-radio class="font-13" value="no">No</b-form-radio>
            </b-form-radio-group>
          </div>
          <div class="row mb-20">
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="4">
                  <div class="label-name font-13">Where?</div>
                </b-col>
                <b-col sm="8">
                  <b-form-input class="form-control border-bottom" name="question" v-model="addData.question_where_fitness_club" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="4">
                  <div class="label-name font-13">Still?</div>
                </b-col>
                <b-col sm="8">
                  <b-form-select name="category" v-model="addData.question_still_membership" class="form-control border-bottom">
                    <option value="null" selected>Please select</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </b-form-select>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="4">
                  <div class="label-name font-13">Why did you stop?</div>
                </b-col>
                <b-col sm="8">
                  <b-form-input class="form-control border-bottom" name="question" v-model="addData.question_why_stop_membership" type="text"></b-form-input>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="4">
                  <div class="label-name font-13">Why Not?</div>
                </b-col>
                <b-col sm="8">
                  <b-form-input class="form-control border-bottom" name="question" v-model="addData.question_why_not" type="text"></b-form-input>
                </b-col>
              </b-row>
            </div>
          </div>
          <div class="row mb-30">
            <div class="col-lg-12">
              <b-row class="mb-20">
                <b-col sm="4">
                  <div class="label-name font-13">What are you currently doing for exercise?</div>
                </b-col>
                <b-col sm="8">
                  <b-form-input class="form-control border-bottom" name="question" v-model="addData.question_currently_exercise" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="4">
                  <div class="label-name font-13">When was the last time you worked out?</div>
                </b-col>
                <b-col sm="8">
                  <b-form-input class="form-control border-bottom" name="question" v-model="addData.question_last_time_workout" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="4">
                  <div class="label-name font-13">What’s your favorite thing to do?</div>
                </b-col>
                <b-col sm="8">
                  <b-form-input class="form-control border-bottom" name="question" v-model="addData.question_favourite_thing" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="4">
                  <div class="label-name font-13">When was the last time you were in great shape?</div>
                </b-col>
                <b-col sm="8">
                  <b-form-input class="form-control border-bottom" name="question" v-model="addData.question_last_great_shape" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="4">
                  <div class="label-name font-13">How did you feel</div>
                </b-col>
                <b-col sm="8">
                  <b-form-input class="form-control border-bottom" name="question" v-model="addData.question_your_feel" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="4">
                  <div class="label-name font-13">How do you rate your energy levels now?</div>
                </b-col>
                <b-col sm="8">
                  <b-form-radio-group class="radio-custom-list" v-model="addData.question_current_energy_level" id="radioEnergyNow" name="radioEnergyNow">
                    <b-form-radio class="font-13" value="1">1</b-form-radio>
                    <b-form-radio class="font-13" value="2">2</b-form-radio>
                    <b-form-radio class="font-13" value="3">3</b-form-radio>
                    <b-form-radio class="font-13" value="4">4</b-form-radio>
                    <b-form-radio class="font-13" value="5">5</b-form-radio>
                    <b-form-radio class="font-13" value="6">6</b-form-radio>
                    <b-form-radio class="font-13" value="7">7</b-form-radio>
                    <b-form-radio class="font-13" value="8">8</b-form-radio>
                    <b-form-radio class="font-13" value="9">9</b-form-radio>
                    <b-form-radio class="font-13" value="10">10</b-form-radio>
                  </b-form-radio-group>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="4">
                  <div class="label-name font-13">Where do you want your energy levels to be?</div>
                </b-col>
                <b-col sm="8">
                  <b-form-radio-group class="radio-custom-list" v-model="addData.question_target_energy_level" id="radioEnergyWant" name="radioEnergyWant">
                    <b-form-radio class="font-13" value="1">1</b-form-radio>
                    <b-form-radio class="font-13" value="2">2</b-form-radio>
                    <b-form-radio class="font-13" value="3">3</b-form-radio>
                    <b-form-radio class="font-13" value="4">4</b-form-radio>
                    <b-form-radio class="font-13" value="5">5</b-form-radio>
                    <b-form-radio class="font-13" value="6">6</b-form-radio>
                    <b-form-radio class="font-13" value="7">7</b-form-radio>
                    <b-form-radio class="font-13" value="8">8</b-form-radio>
                    <b-form-radio class="font-13" value="9">9</b-form-radio>
                    <b-form-radio class="font-13" value="10">10</b-form-radio>
                  </b-form-radio-group>
                </b-col>
              </b-row>
            </div>
          </div>
          <div class="font-bold mt-20">Goals</div>
          <hr class="short-line left">
          <div class="mb-20">What’s your number 1 fitness goal?</div>
          <div class="mb-20">
            <table class="table-checkbox">
              <thead>
                <tr>
                  <th></th>
                  <th>Goal</th>
                  <th>How Much</th>
                  <th>Where</th>
                  <th>Time Frame</th>
                  <th>Why</th>
                </tr>
              </thead>
              <tbody>
                <tr :class="{'disable-row': checkedRow1 == false}">
                  <td><input type="checkbox" v-model="checkedRow1" value=""></td>
                  <td>Lose Weight</td>
                  <td><b-form-input v-model="addData.leads_eha_form_goals.goals_lose_weight_how_much" class="form-control border-bottom" name="goal_input" type="text"></b-form-input></td>
                  <td><b-form-input v-model="addData.leads_eha_form_goals.goals_lose_weight_where" class="form-control border-bottom" name="goal_input" type="text"></b-form-input></td>
                  <td><b-form-input v-model="addData.leads_eha_form_goals.goals_lose_weight_time_frame" class="form-control border-bottom" name="goal_input" type="text"></b-form-input></td>
                  <td><b-form-input v-model="addData.leads_eha_form_goals.goals_lose_weight_why" class="form-control border-bottom" name="goal_input" type="text"></b-form-input></td>
                </tr>
                <tr :class="{'disable-row': checkedRow2 == false}">
                  <td><input type="checkbox" v-model="checkedRow2" value=""></td>
                  <td>Gain Weight</td>
                  <td><b-form-input v-model="addData.leads_eha_form_goals.goals_gain_weight_how_much" class="form-control border-bottom" name="goal_input" type="text"></b-form-input></td>
                  <td><b-form-input v-model="addData.leads_eha_form_goals.goals_gain_weight_where" class="form-control border-bottom" name="goal_input" type="text"></b-form-input></td>
                  <td><b-form-input v-model="addData.leads_eha_form_goals.goals_gain_weight_time_frame" class="form-control border-bottom" name="goal_input" type="text"></b-form-input></td>
                  <td><b-form-input v-model="addData.leads_eha_form_goals.goals_gain_weight_why" class="form-control border-bottom" name="goal_input" type="text"></b-form-input></td>
                </tr>
                <tr :class="{'disable-row': checkedRow3 == false}">
                  <td><input type="checkbox" v-model="checkedRow3" value=""></td>
                  <td>Tone & Firm</td>
                  <td><b-form-input v-model="addData.leads_eha_form_goals.goals_tone_firm_how_much" class="form-control border-bottom" name="goal_input" type="text"></b-form-input></td>
                  <td><b-form-input v-model="addData.leads_eha_form_goals.goals_tone_firm_where" class="form-control border-bottom" name="goal_input" type="text"></b-form-input></td>
                  <td><b-form-input v-model="addData.leads_eha_form_goals.goals_tone_firm_time_frame" class="form-control border-bottom" name="goal_input" type="text"></b-form-input></td>
                  <td><b-form-input v-model="addData.leads_eha_form_goals.goals_tone_firm_why" class="form-control border-bottom" name="goal_input" type="text"></b-form-input></td>
                </tr>
                <tr :class="{'disable-row': checkedRow4 == false}">
                  <td><input type="checkbox" v-model="checkedRow4" value=""></td>
                  <td>Improve Fitness</td>
                  <td><b-form-input v-model="addData.leads_eha_form_goals.goals_improve_fitness_how_much" class="form-control border-bottom" name="goal_input" type="text"></b-form-input></td>
                  <td><b-form-input v-model="addData.leads_eha_form_goals.goals_improve_fitness_where" class="form-control border-bottom" name="goal_input" type="text"></b-form-input></td>
                  <td><b-form-input v-model="addData.leads_eha_form_goals.goals_improve_fitness_time_frame" class="form-control border-bottom" name="goal_input" type="text"></b-form-input></td>
                  <td><b-form-input v-model="addData.leads_eha_form_goals.goals_improve_fitness_why" class="form-control border-bottom" name="goal_input" type="text"></b-form-input></td>
                </tr>
                <tr :class="{'disable-row': checkedRow5 == false}">
                  <td><input type="checkbox" v-model="checkedRow5" value=""></td>
                  <td>Increase Strength</td>
                  <td><b-form-input v-model="addData.leads_eha_form_goals.goals_increase_strength_how_much" class="form-control border-bottom" name="goal_input" type="text"></b-form-input></td>
                  <td><b-form-input v-model="addData.leads_eha_form_goals.goals_increase_strength_where" class="form-control border-bottom" name="goal_input" type="text"></b-form-input></td>
                  <td><b-form-input v-model="addData.leads_eha_form_goals.goals_increase_strength_time_frame" class="form-control border-bottom" name="goal_input" type="text"></b-form-input></td>
                  <td><b-form-input v-model="addData.leads_eha_form_goals.goals_increase_strength_why" class="form-control border-bottom" name="goal_input" type="text"></b-form-input></td>
                </tr>
                <tr :class="{'disable-row': checkedRow6 == false}">
                  <td><input type="checkbox" v-model="checkedRow6" value=""></td>
                  <td>Increase Muscular Size</td>
                  <td><b-form-input v-model="addData.leads_eha_form_goals.goals_increase_muscular_size_how_much" class="form-control border-bottom" name="goal_input" type="text"></b-form-input></td>
                  <td><b-form-input v-model="addData.leads_eha_form_goals.goals_increase_muscular_size_where" class="form-control border-bottom" name="goal_input" type="text"></b-form-input></td>
                  <td><b-form-input v-model="addData.leads_eha_form_goals.goals_increase_muscular_size_time_frame" class="form-control border-bottom" name="goal_input" type="text"></b-form-input></td>
                  <td><b-form-input v-model="addData.leads_eha_form_goals.goals_increase_muscular_size_why" class="form-control border-bottom" name="goal_input" type="text"></b-form-input></td>
                </tr>
                <tr :class="{'disable-row': checkedRow7 == false}">
                  <td><input type="checkbox" v-model="checkedRow7" value=""></td>
                  <td>Reduce Stress</td>
                  <td><b-form-input v-model="addData.leads_eha_form_goals.goals_reduce_stress_how_much" class="form-control border-bottom" name="goal_input" type="text"></b-form-input></td>
                  <td><b-form-input v-model="addData.leads_eha_form_goals.goals_reduce_stress_where" class="form-control border-bottom" name="goal_input" type="text"></b-form-input></td>
                  <td><b-form-input v-model="addData.leads_eha_form_goals.goals_reduce_stress_time_frame" class="form-control border-bottom" name="goal_input" type="text"></b-form-input></td>
                  <td><b-form-input v-model="addData.leads_eha_form_goals.goals_reduce_stress_why" class="form-control border-bottom" name="goal_input" type="text"></b-form-input></td>
                </tr>
                <tr :class="{'disable-row': checkedRow8 == false}">
                  <td><input type="checkbox" v-model="checkedRow8" value=""></td>
                  <td>Sport/Running</td>
                  <td><b-form-input v-model="addData.leads_eha_form_goals.goals_sport_how_much" class="form-control border-bottom" name="goal_input" type="text"></b-form-input></td>
                  <td><b-form-input v-model="addData.leads_eha_form_goals.goals_sport_where" class="form-control border-bottom" name="goal_input" type="text"></b-form-input></td>
                  <td><b-form-input v-model="addData.leads_eha_form_goals.goals_sport_time_frame" class="form-control border-bottom" name="goal_input" type="text"></b-form-input></td>
                  <td><b-form-input v-model="addData.leads_eha_form_goals.goals_sport_why" class="form-control border-bottom" name="goal_input" type="text"></b-form-input></td>
                </tr>
                <tr :class="{'disable-row': checkedRow9 == false}">
                  <td><input type="checkbox" v-model="checkedRow9" value=""></td>
                  <td>Other</td>
                  <td><b-form-input v-model="addData.leads_eha_form_goals.goals_other_how_much" class="form-control border-bottom" name="goal_input" type="text"></b-form-input></td>
                  <td><b-form-input v-model="addData.leads_eha_form_goals.goals_other_where" class="form-control border-bottom" name="goal_input" type="text"></b-form-input></td>
                  <td><b-form-input v-model="addData.leads_eha_form_goals.goals_other_time_frame" class="form-control border-bottom" name="goal_input" type="text"></b-form-input></td>
                  <td><b-form-input v-model="addData.leads_eha_form_goals.goals_other_why" class="form-control border-bottom" name="goal_input" type="text"></b-form-input></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="row mb-20">
            <div class="col-lg-12">
              <b-row class="mb-20">
                <b-col sm="4">
                  <div class="label-name">What’s been holding you back until now?</div>
                </b-col>
                <b-col sm="8">
                  <b-form-input class="form-control border-bottom" name="question" v-model="addData.question_holding_back" type="text"></b-form-input>
                </b-col>
              </b-row>
            </div>
          </div>
          <div class="font-bold mt-20">Goal Planning</div>
          <hr class="short-line left">
          <div class="row mb-20">
            <div class="col-lg-12">
              <b-row class="mb-20">
                <b-col sm="4">
                  <div class="label-name">How serious are you about achieving?</div>
                </b-col>
                <b-col sm="8">
                  <b-form-input class="form-control border-bottom" name="question" v-model="addData.question_achieving" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="4">
                  <div class="label-name">How many times per week do you plan to exercise?</div>
                </b-col>
                <b-col sm="8">
                  <b-form-radio-group class="radio-custom-list" v-model="addData.question_plan_exercise" id="planExercise" name="planExercise">
                    <b-form-radio class="font-13" value="1">1</b-form-radio>
                    <b-form-radio class="font-13" value="2">2</b-form-radio>
                    <b-form-radio class="font-13" value="3">3</b-form-radio>
                    <b-form-radio class="font-13" value="4">4</b-form-radio>
                    <b-form-radio class="font-13" value="5">5</b-form-radio>
                    <b-form-radio class="font-13" value="6">6</b-form-radio>
                    <b-form-radio class="font-13" value="7">7 (days)</b-form-radio>
                  </b-form-radio-group>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="4">
                  <div class="label-name">And for how long?</div>
                </b-col>
                <b-col sm="8">
                  <b-form-radio-group class="radio-custom-list" v-model="addData.question_how_long" id="longExercise" name="longExercise">
                    <b-form-radio class="font-13" value="30">30</b-form-radio>
                    <b-form-radio class="font-13" value="60">60</b-form-radio>
                    <b-form-radio class="font-13" value="90">90 (Mins)</b-form-radio>
                  </b-form-radio-group>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="4">
                  <div class="label-name">Have you ever hired a Personal Trainer before?</div>
                </b-col>
                <b-col sm="8">
                  <b-form-radio-group class="radio-custom-list" v-model="addData.question_hire_pt" id="havePt" name="havePt">
                    <b-form-radio class="font-13" value="yes">Yes</b-form-radio>
                    <b-form-radio class="font-13" value="no">No</b-form-radio>
                  </b-form-radio-group>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="4">
                  <div class="label-name">Who will be supporting you on your efforts to achieving your goals?</div>
                </b-col>
                <b-col sm="8">
                  <b-form-radio-group class="radio-custom-list" v-model="addData.question_effort_supporter" id="goalSupport" name="goalSupport">
                    <b-form-radio class="font-13" value="partner">Partner</b-form-radio>
                    <b-form-radio class="font-13" value="spouse">Spouse</b-form-radio>
                    <b-form-radio class="font-13" value="doctor">Doctor</b-form-radio>
                    <b-form-radio class="font-13" value="friends">Friends</b-form-radio>
                  </b-form-radio-group>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="4">
                  <div class="label-name">Comments</div>
                </b-col>
                <b-col sm="8">
                  <b-form-input class="form-control border-bottom" name="question" v-model="addData.question_comments" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="4">
                  <div class="label-name">Injury Details</div>
                </b-col>
                <b-col sm="8">
                  <b-form-input class="form-control border-bottom" name="question" v-model="addData.question_injury_details" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="4">
                  <div class="label-name">What type of injury</div>
                </b-col>
                <b-col sm="8">
                  <b-form-input class="form-control border-bottom" name="question" v-model="addData.question_injury_type" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="4">
                  <div class="label-name">When did the injury occur?</div>
                </b-col>
                <b-col sm="8">
                  <b-form-input class="form-control border-bottom" name="question" v-model="addData.question_when_injury_occur" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="4">
                  <div class="label-name">Guest Type</div>
                </b-col>
                <b-col sm="8">
                  <b-form-select name="category" v-model="addData.question_guess_type" class="form-control border-bottom">
                    <option value="null" selected>Please select</option>
                    <option value="appoinment">Appoinment</option>
                    <option value="walkIn">Walk In</option>
                  </b-form-select>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="4">
                  <div class="label-name">Guest Pass</div>
                </b-col>
                <b-col sm="8">
                  <b-form-radio-group class="radio-custom-list" v-model="addData.question_guess_pass" >
                    <b-form-radio class="font-13" value="yes">Yes</b-form-radio>
                    <b-form-radio class="font-13" value="no">No</b-form-radio>
                  </b-form-radio-group>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="4">
                  <div class="label-name">Toured by?</div>
                </b-col>
                <b-col sm="8">
                  <b-form-select v-model="addData.question_toured_by_id" class="form-control border-bottom">
                    <option value="null">Please select</option>
                    <option v-for="item in itemSales" :key="item.id" :value="item.id">{{item.fullname}}</option>
                  </b-form-select>
                </b-col>
              </b-row>
            </div>
          </div>
          <div class="text-right">
            <button v-if="!isViewOnly" type="submit" class="btn-primary">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'

export default {
  name: 'ehaEdit',
  data: function () {
    return {
      formEmpty: '',
      checkedRow1: false,
      checkedRow2: false,
      checkedRow3: false,
      checkedRow4: false,
      checkedRow5: false,
      checkedRow6: false,
      checkedRow7: false,
      checkedRow8: false,
      checkedRow9: false,
      isViewOnly: false,
      membership: '',
      itemSales: [],
      id_lead_member: '',
      id_lead: '',
      addData: false,
      addAppointment: {
        leads_id: '',
        subject: '',
        leads_activity_type_id: '4',
        leads_activity_status_id: '4',
        leads_source_type_id: '1',
        due_date: moment(new Date()).format('YYYY-MM-DD'),
        start_time: '07:00',
        appointment_status: 'show',
        appointment_show_status: null,
        appointment_missed_guest_status: null
      },
      options: [
        { value: null, text: 'Please select' },
        { value: 'active', text: 'Active' },
        { value: 'inactive', text: 'Inactive' }
      ]
    }
  },
  methods: {
    // skip_activity=1 — endpoint ini biasanya juga bikin leads_activity "Show" kalau
    // belum ada (dipakai flow isi EHA pertama kali di leads/eha.vue). Untuk edit dari
    // memberData, tujuannya cuma update data, jadi efek samping itu sengaja dimatikan.
    validateRegister () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.addData.leads_id = this.id_lead
          let data1 = Object.assign({}, this.addData)
          let data2 = data1.leads_eha_form_goals
          delete data1.leads_eha_form_goals
          let data3 = {
            ...data2,
            ...data1
          }
          axios.put('crm/v1/leads_eha_form/' + this.id_lead + '?skip_activity=1', data3).then(() => {
            this.$router.push('/memberData/detail?id=' + this.id_lead_member + '&id_lead=' + this.id_lead)
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }).catch(error => {
            console.log('error', error)
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    openPage (event) {
      this.$router.push(event)
    },
    fetchData() {
      axios.get('crm/v1/sales').then(response => {
        this.itemSales = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('crm/v1/leads_eha_form/' + this.id_lead).then(response => {
        this.addData = response.data.data
        if (!(response.data.data.leads_eha_form_goals.goals_lose_weight_how_much === '') || !(response.data.data.leads_eha_form_goals.goals_lose_weight_where === '') ||
          !(response.data.data.leads_eha_form_goals.goals_lose_weight_time_frame === '') || !(response.data.data.leads_eha_form_goals.goals_lose_weight_why === '')) {
          this.checkedRow1 = true
        }
        if (!(response.data.data.leads_eha_form_goals.goals_gain_weight_how_much === '') || !(response.data.data.leads_eha_form_goals.goals_gain_weight_where === '') || !(response.data.data.leads_eha_form_goals.goals_gain_weight_time_frame === '') || !(response.data.data.leads_eha_form_goals.goals_gain_weight_why === '')) {
          this.checkedRow2 = true
        }
        if (!(response.data.data.leads_eha_form_goals.goals_tone_firm_how_much === '') || !(response.data.data.leads_eha_form_goals.goals_tone_firm_where === '') || !(response.data.data.leads_eha_form_goals.goals_tone_firm_time_frame === '') || !(response.data.data.leads_eha_form_goals.goals_tone_firm_why === '')) {
          this.checkedRow3 = true
        }
        if (!(response.data.data.leads_eha_form_goals.goals_improve_fitness_how_much === '') || !(response.data.data.leads_eha_form_goals.goals_improve_fitness_where === '') || !(response.data.data.leads_eha_form_goals.goals_improve_fitness_time_frame === '') || !(response.data.data.leads_eha_form_goals.goals_improve_fitness_why === '')) {
          this.checkedRow4 = true
        }
        if (!(response.data.data.leads_eha_form_goals.goals_increase_strength_how_much === '') || !(response.data.data.leads_eha_form_goals.goals_increase_strength_where === '') || !(response.data.data.leads_eha_form_goals.goals_increase_strength_time_frame === '') || !(response.data.data.leads_eha_form_goals.goals_increase_strength_why === '')) {
          this.checkedRow5 = true
        }
        if (!(response.data.data.leads_eha_form_goals.goals_increase_muscular_size_how_much === '') || !(response.data.data.leads_eha_form_goals.goals_increase_muscular_size_where === '') || !(response.data.data.leads_eha_form_goals.goals_increase_muscular_size_time_frame === '') || !(response.data.data.leads_eha_form_goals.goals_increase_muscular_size_why === '')) {
          this.checkedRow6 = true
        }
        if (!(response.data.data.leads_eha_form_goals.goals_reduce_stress_how_much === '') || !(response.data.data.leads_eha_form_goals.goals_reduce_stress_where === '') || !(response.data.data.leads_eha_form_goals.goals_reduce_stress_time_frame === '') || !(response.data.data.leads_eha_form_goals.goals_reduce_stress_why === '')) {
          this.checkedRow7 = true
        }
        if (!(response.data.data.leads_eha_form_goals.goals_sport_how_much === '') || !(response.data.data.leads_eha_form_goals.goals_sport_where === '') || !(response.data.data.leads_eha_form_goals.goals_sport_time_frame === '') || !(response.data.data.leads_eha_form_goals.goals_sport_why === '')) {
          this.checkedRow8 = true
        }
        if (!(response.data.data.leads_eha_form_goals.goals_other_how_much === '') || !(response.data.data.leads_eha_form_goals.goals_other_where === '') || !(response.data.data.leads_eha_form_goals.goals_other_time_frame === '') || !(response.data.data.leads_eha_form_goals.goals_other_why === '')) {
          this.checkedRow9 = true
        }
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.id_lead_member = this.$route.query.id
    this.id_lead = this.$route.query.id_lead
    this.fetchData()

    const roleMapping = Auth.Session.get().paradigm_role_mapping_id
    const roleId = Auth.Session.get().paradigm_role
    if (roleMapping.includes(17)) {
      this.isViewOnly = false
    } else if (Number(roleId) == 33) {
      this.isViewOnly = true
    }
  }
}
</script>

<style>
</style>
